import {
  CV_REQUEST, CV_SUCCESS, CV_FAIL,
  COMPETENCES_REQUEST, COMPETENCES_SUCCESS, COMPETENCES_FAIL,
  PUBLICATIONS_REQUEST, PUBLICATIONS_SUCCESS, PUBLICATIONS_FAIL,
  HONORS_REQUEST, HONORS_SUCCESS, HONORS_FAIL,
  CONTACT_REQUEST, CONTACT_SUCCESS, CONTACT_FAIL,
} from '../constants/portfolioConstants'

export const cvReducer = (state = { work: [], education: [] }, action) => {
  switch (action.type) {
    case CV_REQUEST:      return { ...state, loading: true }
    case CV_SUCCESS:      return { loading: false, work: action.payload.work, education: action.payload.education }
    case CV_FAIL:         return { loading: false, error: action.payload }
    default:              return state
  }
}

export const competencesReducer = (state = { categories: [] }, action) => {
  switch (action.type) {
    case COMPETENCES_REQUEST: return { ...state, loading: true }
    case COMPETENCES_SUCCESS: return { loading: false, categories: action.payload }
    case COMPETENCES_FAIL:    return { loading: false, error: action.payload }
    default:                  return state
  }
}

export const publicationsReducer = (state = { byType: {} }, action) => {
  switch (action.type) {
    case PUBLICATIONS_REQUEST: return { ...state, loading: true }
    case PUBLICATIONS_SUCCESS: return { loading: false, byType: action.payload }
    case PUBLICATIONS_FAIL:    return { loading: false, error: action.payload }
    default:                   return state
  }
}

export const honorsReducer = (state = { honors: [] }, action) => {
  switch (action.type) {
    case HONORS_REQUEST: return { ...state, loading: true }
    case HONORS_SUCCESS: return { loading: false, honors: action.payload }
    case HONORS_FAIL:    return { loading: false, error: action.payload }
    default:             return state
  }
}

export const contactReducer = (state = { contact: null }, action) => {
  switch (action.type) {
    case CONTACT_REQUEST: return { ...state, loading: true }
    case CONTACT_SUCCESS: return { loading: false, contact: action.payload }
    case CONTACT_FAIL:    return { loading: false, error: action.payload }
    default:              return state
  }
}
